import React from 'react'
import { Divider, Grid, Typography } from '@mui/material';
import BotDetection from './BotDetection';
import LabelButton from '../../components/reusable-components/buttons/LabelButton';
import InnoTextInput from "../../components/inputs/InnoTextInput";



export default function LandingRegPageWithEmail({
    email,
    handleInputEmail,
    validate,
    errors,
    handleContinueWithEmail,
    emailResponseError,
    invitationToken,
    botCheckPassed,
    setBotCheckPassed
}) {
  return (
    <>
      <Divider
        sx={{
          width: "100%",
          color: "var(--Neutrals-900, #6F8090)",
          fontFamily: "Lato",
          fontSize: 14,
          fontWeight: 400,
          "&::before, &::after": {
            borderColor: "var(--Neutrals-900, #6F8090)",
            borderTopWidth: "1px",
          },
        }}>
        Or
      </Divider>
      {/* email for invitation not cps email */}
      <Grid
        item
        sx={{
          width: "100%",
          height: "67px",
        }}>
        <Typography
          sx={{
            color: "#A4A4A4",
            fontFamily: "Lato",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            marginBottom: "10px",
          }}>
          Email
        </Typography>
        <Grid
          item
          sx={{
            width: "100%",
            height: "30px",
          }}>
          <InnoTextInput
            fieldName="email"
            placeholder="Email"
            fieldValue={email}
            setValue={handleInputEmail}
            validate={validate}
            disabled={invitationToken && email}
            width="100%"
            height="40px"
            styledProps={{
              fontFamily: "Lato",
              fontSize: "14px",
              fontWeight: 700,
              fontStyle: "normal",
              color: "var(--Primary-900, #0B0926)",
              placeholder: {
                color: "var(--Neutrals-700, #C6CCD2)",
              },
            }}
            errorIcon={false}
            showErrorIconWithError={false}
            errors={errors}
            feedbackError={!!emailResponseError}
          />
          {emailResponseError && (
            <Typography
              sx={{
                color: "var(--Errors-500, #C30930)",
                fontFamily: "Lato",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
                paddingLeft: "5px",
                marginTop: "0px",
              }}>
              {emailResponseError}
            </Typography>
          )}
        </Grid>
      </Grid>
      {/* bot detection */}
      <BotDetection
        botCheckPassed={botCheckPassed}
        setBotCheckPassed={setBotCheckPassed}
      />
      {/* email continue button */}
      <Grid
        item
        sx={{
          width: "100%",
          height: "60px",
        }}>
        <LabelButton
          type="primary"
          variant="contained"
          text={"Continue with email"}
          disabled={!botCheckPassed}
          function={handleContinueWithEmail}
          disableButtonStyle={{
            border: "none",
            background: "var(--Tertiary-100, #EBF8FF)",
            color: "var(--Tertiary-500, #00A6FF)",
            opacity: 0.5,
          }}
        />
      </Grid>
    </>
  );
}
